/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



const basePath = '/questions-and-answers'

const QuestionsAndAnswersEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchQuestionsAndAnswers: builder.query<any, any>({
      query: () => `${basePath}`,
      providesTags:['questions-and-answers']
    }),
    createQuestionAndAnswer: builder.mutation<any, {question: string, answer: string,}>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['questions-and-answers']
    }),
    deleteQuestionAndAnswer: builder.mutation<any, any>({
      query: (id) => ({
        url: `${basePath}?id=${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['questions-and-answers'],
    }),
    updateQuestionAndAnswer: builder.mutation<any, any>({
      query: ({id, body}) => ({
        url: `${basePath}/${id}`,
        method: 'put',
        body,
      }),
      invalidatesTags: ['questions-and-answers'],
    }),

  })

export default QuestionsAndAnswersEndpoints
